import { ActionButton } from './action-button';
import { Empty } from './empty';
import { Filter } from './filter';
import { Header } from './header';
import { List } from './list';
import { Pagination } from './pagination';
import { Providers, Root } from './root';
import { SearchBar } from './search-bar';
import { Separator } from './separator';
import { Toolbar } from './toolbar';

/**
 * Compound template for player-list style screens.
 *
 * Minimal usage:
 * ```tsx
 * <PlayerListTemplateV2.Providers userUid={uid}>
 *   <ScreenContent />
 * </PlayerListTemplateV2.Providers>
 *
 * function ScreenContent() {
 *   const logic = useListPlayer();
 *   return (
 *     <PlayerListTemplateV2.Root listLogic={logic} loadingText="...">
 *       <PlayerListTemplateV2.Header>
 *         <AppHeader>...</AppHeader>
 *       </PlayerListTemplateV2.Header>
 *       <PlayerListTemplateV2.Toolbar titleResultsSummary="...">
 *         <PlayerListTemplateV2.SearchBar />
 *         <PlayerListTemplateV2.Filter />
 *         <PlayerListTemplateV2.Pagination />
 *         <PlayerListTemplateV2.ActionButton mobile={...} tablet={...} />
 *       </PlayerListTemplateV2.Toolbar>
 *       <PlayerListTemplateV2.List
 *         renderItem={renderItem}
 *         numberOfColumns={{ phone: 1, tablet: 3 }}
 *         gap={scale(12)}
 *       />
 *     </PlayerListTemplateV2.Root>
 *   );
 * }
 * ```
 */
export const PlayerListTemplateV2 = {
  Root,
  Providers,
  Header,
  Toolbar,
  SearchBar,
  Filter,
  Pagination,
  ActionButton,
  List,
  Empty,
  Separator,
};

export { usePlayerListTemplate } from './context';
export type { PlayerListTemplateV2HeaderProps } from './header';
export type { PlayerListTemplateV2ListProps } from './list';
export type { PlayerListTemplateV2RootProps } from './root';
export type { PlayerListTemplateV2SearchBarProps } from './search-bar';
export type { PlayerListTemplateV2ToolbarProps } from './toolbar';
export type { PlayerListTemplateV2FilterProps } from './filter';
export type { PlayerListTemplateV2PaginationProps } from './pagination';
export type { PlayerListTemplateV2ActionButtonProps } from './action-button';
export type { PlayerListTemplateV2EmptyProps } from './empty';
